<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <!-- 客户加盟商身份选择 -->
          <el-form-item v-if="activeTab === '2'" label="身份：">
            <el-select v-model="query.customerLevelId" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="研修班" :value="6"></el-option>
              <el-option label="体验版" :value="7"></el-option>
              <el-option label="普通用户" :value="8"></el-option>
            </el-select>
          </el-form-item>
          <!-- 业务身份选择 -->
          <el-form-item v-if="activeTab === '3'" label="身份：">
            <el-select v-model="query.customerLevelId" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="营销总监" :value="1"></el-option>
              <el-option label="营销经理" :value="2"></el-option>
              <el-option label="大区经理" :value="3"></el-option>
              <el-option label="地区经理" :value="4"></el-option>
              <el-option label="县区经理" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <!-- 技术身份选择 -->
          <el-form-item v-if="activeTab === '4'" label="身份：">
            <el-select v-model="query.tehlevelId" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="教育总监" :value="1"></el-option>
              <el-option label="督导" :value="2"></el-option>
              <el-option label="技术老师" :value="3"></el-option>
              <el-option label="带教老师" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号：">
            <el-input v-model="query.pho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <!-- 是否是大客户 - 只在客户加盟商tab下显示 -->
          <el-form-item v-if="activeTab === '2'" label="是否是大客户：">
            <el-select v-model="query.isBig" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined"></el-option>
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域：" v-if="activeTab != '1'">
            <el-cascader
              v-model="addressValue"
              :options="addressOptions"
              :props="cascaderProps"
              placeholder="请选择区域（建议选择到区级）"
              clearable
              size="small"
              @change="handleAddressChange"
              @visible-change="handleCascaderVisibleChange"
              style="width: 250px;"
            ></el-cascader>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <el-row type="flex" justify="space-between" style="margin-bottom: 10px;">
        <el-col :span="12">
          <!-- 用户类型Tab -->
          <el-tabs v-model="activeTab" @tab-click="handleTabClick" style="display: inline-block;">
            <el-tab-pane label="客户加盟商" name="2"></el-tab-pane>
            <el-tab-pane label="业务" name="3"></el-tab-pane>
            <el-tab-pane label="技术" name="4"></el-tab-pane>
            <el-tab-pane label="内部员工" name="1"></el-tab-pane>
          </el-tabs>
        </el-col>
        <el-col :span="12" style="text-align: right;">
          <el-button type="primary" size="mini" @click="handleExport" plain :loading="exportLoading">导出</el-button>
        </el-col>
      </el-row>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="用户名称" prop="name" align="center" /> 
        <el-table-column label="身份" prop="positionName" align="center" />       
        <el-table-column label="手机号" prop="phone" align="center" />
        <el-table-column label="所属区域" prop="fullAddr" align="center" />
        <!-- <el-table-column label="是否是大客户" prop="isBig" align="center">
          <template slot-scope="{row}">
            {{ row.isBig ? '是' : '否' }}
          </template>
        </el-table-column> -->
        <el-table-column label="是否是大客户" prop="isBig" align="center"/>
       <!-- // <el-table-column label="区域客户名称" prop="areaCustomerName" align="center" /> -->
      
        <el-table-column label="所属大区" prop="areaCustomerName" align="center" />
        <el-table-column label="技术线" prop="jishuline" align="center" />
      
        <el-table-column label="观看直播场次" prop="lookCount" align="center" />
        <el-table-column label="观看直播总时长" prop="lookTimeSpan" align="center" />
        <el-table-column label="最后观看直播时间" prop="lastLookTime" align="center" />
        <el-table-column label="操作" align="center" width="120" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleShow(row)">查看直播</el-button>
            <!-- <el-button type="text" @click="handleDetailExport(row)">导出</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import liveManageApi from '@/api/live/liveManage'
import Pagination from '@/components/Pagination'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      exportLoading: false,
      activeTab: '2', // 默认选择客户加盟商
      query: {
        pageNo: 1,
        pageSize: 10,
        pho: '', // 手机号
        isBig: undefined,
        userType: 2, // 默认客户加盟商
        customerLevelId: undefined, // 业务和客户的等级ID
        tehlevelId: undefined, // 技术老师的等级ID
        addrProvinceCode: undefined, // 省
        addrCityCode: undefined, // 市
        addrAreaCode: undefined // 区
      },
      selectItems: [],
      // 区域级联选择器相关数据
      addressValue: [], // 级联选择器的值
      addressOptions: [], // 区域选项数据
      cascaderProps: {
        value: 'regionCode',
        label: 'regionName',
        children: 'child',
        checkStrictly: false, // 必须选择到叶子节点，自动选中父级
        emitPath: true // 返回完整路径
      }
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.loadAddressData()
  },
  methods: {
    /**
     * 清理区域数据，移除空的子级
     */
    cleanAddressData(data) {
      if (!data || !Array.isArray(data)) return data
      
      return data.map(item => {
        const cleanedItem = { ...item }
        if (cleanedItem.child && Array.isArray(cleanedItem.child)) {
          // 递归清理子级数据
          cleanedItem.child = this.cleanAddressData(cleanedItem.child)
          // 如果子级为空数组，则移除child属性
          if (cleanedItem.child.length === 0) {
            delete cleanedItem.child
          }
        }
        return cleanedItem
      }).filter(item => {
        // 过滤掉没有有效数据的项
        return item && item.regionCode && item.regionName
      })
    },
    /**
     * 加载区域数据
     */
    loadAddressData() {
      liveManageApi.getAddressTreeList()
        .then(response => {
          console.log('区域数据接口响应:', response)
          if (response.code === '0' && response.data) {
            // 清理数据，移除空的子级
            this.addressOptions = this.cleanAddressData(response.data)
            console.log('原始区域数据:', response.data)
            console.log('清理后区域数据:', this.addressOptions)
            console.log('区域数据加载成功')
          } else {
            console.error('区域数据加载失败:', response.message)
            this.$message.error('加载区域数据失败: ' + response.message)
          }
        })
        .catch(error => {
          console.error('加载区域数据失败:', error)
          this.$message.error('加载区域数据失败')
        })
    },
    /**
     * 级联选择器可见性变化处理
     */
    handleCascaderVisibleChange(visible) {
      console.log('级联选择器可见性变化:', visible)
      if (visible) {
        console.log('当前区域选项数据:', this.addressOptions)
      }
    },
    /**
     * 区域级联选择器变化处理
     */
    handleAddressChange(value) {
      console.log('区域选择变化:', value)
      if (value && value.length > 0) {
        // 确保选择到区级时，前面的省市也要设置
        this.query.addrProvinceCode = value[0] || undefined
        this.query.addrCityCode = value[1] || undefined
        this.query.addrAreaCode = value[2] || undefined
        
        console.log('设置的完整地址参数:', {
          addrProvinceCode: this.query.addrProvinceCode,
          addrCityCode: this.query.addrCityCode,
          addrAreaCode: this.query.addrAreaCode,
          selectedPath: value
        })
        
        // 如果选择了区级，确保前面的省市也被选中
        if (value.length === 3) {
          console.log('已选择到区级，省市参数已自动设置')
        }
      } else {
        // 清空所有地址参数
        this.query.addrProvinceCode = undefined
        this.query.addrCityCode = undefined
        this.query.addrAreaCode = undefined
        console.log('清空地址参数')
      }
    },
    /**
     * Tab切换处理
     */
    handleTabClick(tab) {
      this.query.userType = parseInt(tab.name)
      // 清空其他等级参数
      this.query.customerLevelId = undefined
      this.query.tehlevelId = undefined
      // 如果不是客户加盟商，清空是否是大客户参数
      if (tab.name !== '2') {
        this.query.isBig = undefined
      }
      // 清空区域选择器数据
      this.addressValue = []
      this.query.addrProvinceCode = undefined
      this.query.addrCityCode = undefined
      this.query.addrAreaCode = undefined
      this.query.customerLevelId = undefined
      this.query.tehlevelId = undefined
      this.query.isBig = undefined
      this.query.pho = ''
      this.query.pageNo = 1
      this.query.pageSize = 10
      this.doQueryList({ pageNo: 1 })
    },
    handleExport() {
      // 先请求导出接口获取任务code，然后跳转到导出页面
      this.exportLoading = true
      
      // 准备导出参数，只传递有值的参数
      const exportParams = {}
      
      // 只添加有值的参数
      if (this.query.addrAreaCode) {
        exportParams.addrAreaCode = this.query.addrAreaCode
      }
      if (this.query.addrCityCode) {
        exportParams.addrCityCode = this.query.addrCityCode
      }
      if (this.query.addrProvinceCode) {
        exportParams.addrProvinceCode = this.query.addrProvinceCode
      }
      if (this.query.customerLevelId !== undefined && this.query.customerLevelId !== null) {
        exportParams.customerLevelId = this.query.customerLevelId
      }
      if (this.query.isBig !== undefined && this.query.isBig !== null) {
        exportParams.isBig = this.query.isBig
      }
      if (this.query.pho && this.query.pho.trim()) {
        exportParams.pho = this.query.pho.trim()
      }
      if (this.query.tehlevelId !== undefined && this.query.tehlevelId !== null) {
        exportParams.tehlevelId = this.query.tehlevelId
      }
      if (this.query.userType !== undefined && this.query.userType !== null) {
        exportParams.userType = this.query.userType
      }
      
      console.log('导出参数:', exportParams)
      
      // 先请求导出接口创建任务
      liveManageApi.downloadStatisticsByUser(exportParams)
        .then(response => {
          console.log('导出任务创建响应:', response)
          if (response.data && response.data.code) {
            // 获取任务code，跳转到导出页面
            this.$router.push({
              path: '/export/list',
              query: {
                code: response.data.code
              }
            })
            this.$message.success('导出任务已创建，正在跳转到下载页面')
          } else {
            this.$message.error('导出失败：未获取到任务代码')
          }
        })
        .catch(error => {
          console.error('导出任务创建失败:', error)
          this.$message.error('导出任务创建失败：' + (error.message || '未知错误'))
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 10,
        pho: '',
        isBig: undefined,
        userType: 2, // 重置为默认的客户加盟商
        customerLevelId: undefined,
        tehlevelId: undefined,
        addrProvinceCode: undefined,
        addrCityCode: undefined,
        addrAreaCode: undefined
      }
      this.activeTab = '2' // 重置tab为默认选择
      this.addressValue = [] // 重置区域选择器
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return liveManageApi.fetchLiveStatisticsByUser(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    /**
     * 删除单条记录
     */
    handleDeleteSingle(row) {
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteById(row.id))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    /**
     * 批量删除记录
     */
    handleDeleteBatch() {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      return this.$common.confirm('是否确认删除')
        .then(() => sysGoodsCategorizeApi.deleteBatch(this.selectItems.map(row => row.id)))
        .then(() => {
          this.$common.showMsg('success', '删除成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    beforeHandleCommand(row, command) {
      return {
        'row': row,
        'command': command
      }
    },
    handleCommand(command) {
      if (this.selectItems.length <= 0) {
        this.$common.showMsg('warning', '请选择')
        return
      }
      let ids = this.selectItems.map(row => row.id)
      let txt = ""
      if (command.command === 1) {
        this.handleBatchState(ids, 1)
      } else if (command.command === 2) {
        this.handleBatchState(ids, 0)
      }
    },
    handleBatchState(ids, type) {
      let txt = type === 1 ? '确认将选中批量启用？' : '确认将选中批量禁用？'
      this.$common.confirm(txt).then(() => sysGoodsCategorizeApi.setIsEnableBatch({ ids: ids, isEnable: type ? true : false }))
        .then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
    },
    changeSwitch(row) {
      sysGoodsCategorizeApi.setIsEnable({ id: row.id, isEnable: row.isEnable }).then(() => {
        this.$common.showMsg('success', '操作成功')
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.liveAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row) {
      // 跳转到用户活跃度详情页面，传递用户ID
      this.$router.push({
        path: '/live/liveActive/show',
        query: { userId: row.userId }
      })
    },
    /**
     * 用户活跃度详情导出
     */
    handleDetailExport(row) {
      // 跳转到用户活跃度详情导出页面，传递用户ID
      this.$router.push({
        path: '/export/list/userActivityDetail',
        query: { userId: row.userId }
      })
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.liveAdd.handleUpdate(row)
    }
  }
}
</script>
